/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isBrowser } from 'react-device-detect';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { SendCryptoScreensFlow } from '../../constants';
import ChecklistOption from '../../../../components/Checklist';
import Alert from '../../../../components/Alert';
import { GET_WHITELIST_ADDRESSES } from '../../queries';
import { tagColors, tags } from './constants';
import { maskCoinAddress } from '../../../../utilities/helpers';

const sortLastUsageDesc = (a, b) => (new Date(a.last_usage) < new Date(b.last_usage) ? 1 : -1);

const WhitelistSelectAddress = ({ openScreen, wallet }) => {
  const { t: translate } = useTranslation();
  const {
    data: whitelistedAddresses,
    refetch: getWhitelistAddresses,
    isLoading: isLoadingWhitelistedAddresses,
  } = useQuery([GET_WHITELIST_ADDRESSES, { coin_id: wallet?.coin_id }], {}, { enabled: false });

  useEffect(() => {
    getWhitelistAddresses();
  }, []);

  const nextScreen = (selectedWallet) => {
    openScreen(SendCryptoScreensFlow.SEND_CRYPTO, { selectedWallet });
  };

  const renderTitle = () => (
    <div
      className={`w-100 ${
        isBrowser ? 'd-flex align-items-center justify-content-between mb-5' : ''
      } `}>
      <div>
        <b className="text-f5 text-dark ms-2">
          {translate('whitelist_title_select_whitelisted').replace(
            '%s',
            wallet?.coin?.toUpperCase()
          )}
        </b>
      </div>
    </div>
  );

  const addWhitelistAddress = useCallback(() => {
    if (!whitelistedAddresses || (whitelistedAddresses && whitelistedAddresses.length === 0)) {
      openScreen(SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL, {
        prevScreen: SendCryptoScreensFlow.WHITELIST_SELECT_ADDRESS,
      });
    } else {
      openScreen(SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES);
    }
  }, [whitelistedAddresses]);

  return (
    <ModalBodyLayout
      withBack
      onPrevClick={() => openScreen(SendCryptoScreensFlow.SEND_CRYPTO)}
      renderTitle={renderTitle}
      renderFooter={() => {}}
      title={null}>
      <div className="d-flex flex-fill flex-column justify-content-start align-content-center h-100">
        <div className="mb-4">
          {whitelistedAddresses &&
            whitelistedAddresses.sort(sortLastUsageDesc).map((option) => {
              let selectedWalletTag;
              if (option.wallet_id) {
                selectedWalletTag = tags.LEDGER;
              } else {
                selectedWalletTag = tags.EXTERNAL;
              }
              return (
                <ChecklistOption
                  key={option.id}
                  title={option.name || option.coin}
                  subTitle={maskCoinAddress(option.wallet_address)}
                  value={option}
                  onClick={() => nextScreen(option)}
                  withCheckbox={false}
                  tag={selectedWalletTag}
                  tagColor={tagColors[selectedWalletTag]}
                  className="mb-2"
                  isChecked
                  withArrow
                />
              );
            })}
        </div>
        <Alert
          type="info"
          isClickable={!isLoadingWhitelistedAddresses}
          icon="info"
          onClick={addWhitelistAddress}>
          {translate('whitelist_address_management')}
        </Alert>
      </div>
    </ModalBodyLayout>
  );
};

export default WhitelistSelectAddress;

WhitelistSelectAddress.propTypes = {
  openScreen: PropTypes.func.isRequired,
  wallet: PropTypes.shape({
    coin: PropTypes.string.isRequired,
    coin_id: PropTypes.string.isRequired,
  }).isRequired,
};
